export const IMAGE_CHANGE = 'IMAGE_CHANGE';



// WEBPACK FOOTER //
// ./src/redux/action-types/ui/imageChange.js